
import React from 'react';
import InfoIcon from './icons/InfoIcon';

const Explanation: React.FC = () => {
  return (
    <div className="bg-navy-blue p-6 rounded-lg shadow-xl mb-8">
      <div className="flex items-center mb-4">
        <InfoIcon className="w-8 h-8 mr-3 text-btc-orange" />
        <h2 className="text-2xl font-bold text-off-white">A Guide to Using the Calculator & Its Limitations</h2>
      </div>
      <div className="space-y-4 text-light-blue text-base">
        <p>
          This tool is designed to provide a simple estimate of your potential profit or loss from a Bitcoin transaction. Here's a breakdown of what it does and what you should keep in mind:
        </p>
        
        <div>
          <h3 className="font-bold text-off-white text-lg mb-2">What It Calculates</h3>
          <ul className="list-disc pl-5 space-y-1">
            <li>
              <strong>Gross Gain/Loss:</strong> It first calculates the basic profit or loss using the formula: <code className="bg-dark-blue p-1 rounded-md text-sm"> (Selling Price - Purchase Price) × BTC Quantity</code>.
            </li>
            <li>
              <strong>Tax Impact:</strong> If you enter a Capital Gains Tax percentage, it calculates the tax amount <strong className="text-white">only on profits</strong>. This tax is then subtracted to show you the <strong className="text-white">Net Gain/Loss</strong>. Losses are not taxed.
            </li>
          </ul>
        </div>
        
        <div>
          <h3 className="font-bold text-off-white text-lg mb-2">Important Limitations</h3>
          <ul className="list-disc pl-5 space-y-1">
            <li>
              <strong>Estimates Only:</strong> The results are purely for informational purposes. The calculation does not account for critical factors like exchange fees, network fees, or price slippage on large orders.
            </li>
            <li>
              <strong>Simplified Tax Model:</strong> The tax calculation is a basic percentage. Real-world tax obligations can be much more complex, varying by jurisdiction, income level, and holding period (long-term vs. short-term gains).
            </li>
            <li>
              <strong>Not Financial Advice:</strong> This tool does not provide financial, tax, or investment advice. Always consult with a qualified financial advisor and a tax professional before making any investment decisions.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Explanation;
